import Vue from 'vue'
import request from '@/helpers/request'

export default {
  GET_SERVICE_CATEGORIES: ({ commit, state }, payload) => {
    const search = payload.search ? payload.search.toLowerCase() : null

    return request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.serviceCategories.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data

        const serviceCategories = data.items
        _.forEach(serviceCategories, serviceCategory => {
          serviceCategory.load = false
          serviceCategory.finish = false
          serviceCategory.opened = Boolean(search)

          if (serviceCategory.services === undefined) {
            serviceCategory.services = []
          } else if (search) {
            const filteredServices = _.filter(serviceCategory.services, service => {
              if (service) {
                if (service.title.toLowerCase().indexOf(search) !== -1) {
                  return true
                }
              }
              return false
            })

            serviceCategory.services = filteredServices
          }
        })

        commit('setServiceCategories', serviceCategories)
      } else {
        // TODO: Show error dialog
      }
    })
  },
  GET_SERVICES: ({ commit, state }, payload) => {
    const serviceCategoryID = payload.serviceCategoryID

    if (serviceCategoryID === undefined) {
      throw new Error('Parameter: "serviceCategoryID", not set!')
    }

    request(
      'GET',
      `${Vue.config.server}/${Vue.config.modules.crm.api.services.all}`,
      {
        params: payload.params,
      },
      true,
    ).then(response => {
      if (response.data.result === 'success') {
        const data = response.data.data

        let finish = false
        if (data.items.length == 0) {
          finish = true
        }

        commit('updateServiceCategory', {
          id: serviceCategoryID,
          key: 'finish',
          value: finish,
        })

        commit('appendServiceCategoryServices', {
          id: serviceCategoryID,
          services: data.items,
        })

        commit('updateServiceCategory', {
          id: serviceCategoryID,
          key: 'load',
          value: false,
        })
      } else {
        // TODO: Show error dialog
      }
    })
  },
}
